export const DorfHelferTypeEnum = {
  OFFER: 'OFFER',
  REQUEST: 'REQUEST'
} as const;

export type DorfHelferTypeEnum =
  (typeof DorfHelferTypeEnum)[keyof typeof DorfHelferTypeEnum];
